// Market.jsx
import React, { useState, useEffect } from "react";
import CardHeader from "./Utils/CardHeaderComponent";
import DropdownNumberMandatory from "./InputComponents/DropdownNumberMandatoryComponent";
import TextNoConfidential from "./InputComponents/TextNoConfidentialComponent";
import RDC from "./Regulation";
import DropDMultiple from "./InputComponents/DropDMultiple";
import TextConfidential from "./InputComponents/TextConfidentialComponent";

import { library } from "@fortawesome/fontawesome-svg-core";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    IconLookup,
    IconDefinition,
    findIconDefinition,
} from "@fortawesome/fontawesome-svg-core";
import Directive from "./Directive";
import Communication from "./Communications";
import DropdownStringMandatory from "./InputComponents/DropdownStringMandatoryComponent";
import DropDTextMultiple from "./InputComponents/DropDTextMultipleComponent";
import EditableTitle from "./InputComponents/EditableTitle";
import Tooltip from "./InputComponents/Tooltip";
library.add(faPlus);
const pluslookup: IconLookup = { prefix: "fas", iconName: "plus" };
const plusDefinition: IconDefinition = findIconDefinition(pluslookup);

interface MarketProps {
    errors: {
        field: string;
        message: string;
    }[];
    dropdownValues: {
        tab: string;
        inputName: string;
        listValue: string[];
    }[];
    tAndP:
    {
        table: string;
        property: string;
        tooltip: string;
        placeholder: string;
        id: string;
    }[];
    isCBE: boolean;
    status: number;
    data: {
        contributions: string[];
        contributionsText: string;
        contributionsSensitive: boolean;
        numberOfActionsToAttractInvestmentOrCreateAwareness: number | null;
        numberOfActionsToAttractInvestmentOrCreateAwarenessText: string;
        numberOfActionsToAttractInvestmentOrCreateAwarenessSensitive: boolean;
        relicableToOtherRegions: string;
        relicableToOtherRegionsText: string;
        relicableToOtherRegionsSensitive: boolean;
        rdcs: {
            name: string;
            ticked: boolean;
            problems: string;
            solutions: string;
            updates: string;
            raisedProblemInECPublicConsultations: string;
            raisedProblemInECPublicConsultationsText: string;
        }[];
        directives: {
            name: string;
            programs: string;
            problems: string;
            solutions: string;
            updates: string;
            raisedProblemInECPublicConsultations: string;
            raisedProblemInECPublicConsultationsText: string;
        }[];
        communications: {
            name: string;
            programs: string;
            problems: string;
            solutions: string;
            updates: string;
            raisedProblemInECPublicConsultations: string;
            raisedProblemInECPublicConsultationsText: string;
        }[];
    };
    handleOnChangeMarket: (
        e?: React.ChangeEvent<any>,
        dropDown?: {
            name: string;
            value: string[];
        }
    ) => void;
    handleOnChangeRDC: (e: React.ChangeEvent<any>, rdcIndex: number) => void;
    handleDeleteRDC: (RDCindex: number) => void;
    handleAddRDC: () => void;
    handleOnChangeDirective: (
        e: React.ChangeEvent<any>,
        rdcIndex: number
    ) => void;
    handleDeleteDirective: (Directiveindex: number) => void;
    handleAddDirective: () => void;
    handleOnChangeCommunication: (
        e: React.ChangeEvent<any>,
        rdcIndex: number
    ) => void;
    handleDeleteCommunication: (Communicationindex: number) => void;
    handleAddCommunication: () => void;
    customLabelValues: {
        table: string;
        property: string;
        value: string;
        id: string;
    }[];
    handleUpdateEditableTitle: (id: string, value: string) => void;
}

function Market({
    data,
    isCBE,
    status,
    errors,
    handleOnChangeMarket,
    handleOnChangeRDC,
    handleDeleteRDC,
    handleAddRDC,
    handleOnChangeDirective,
    handleDeleteDirective,
    handleAddDirective,
    handleOnChangeCommunication,
    handleDeleteCommunication,
    handleAddCommunication,
    dropdownValues,
    customLabelValues,
    handleUpdateEditableTitle,
    tAndP
}: MarketProps) {
    const [isHidden, setIsHidden] = useState(true);
    const toggleVisibility = () => {
        setIsHidden((prevState) => !prevState);
    };
    const [regulationsAreHidden, setRegulationsAreHidden] = useState(false);
    const toggleVisibilityRegulations = () => {
        setRegulationsAreHidden((prevState) => !prevState);
    };
    const [directivesAreHidden, setDirectivesAreHidden] = useState(false);
    const toggleVisibilityDirectives = () => {
        setDirectivesAreHidden((prevState) => !prevState);
    };
    const [communicationsAreHidden, setCommunicationsAreHidden] = useState(false);
    const toggleVisibilityCommunications = () => {
        setCommunicationsAreHidden((prevState) => !prevState);
    };

    const marketErrors = errors
        .filter((error) => error.field === "Market")
        .map((error) => error.message);

    const checkForErrorKeyword = (keyword: string): boolean => {
        const regex = new RegExp(`${keyword}(\\[\\d+\\])?`);
        return errors.some((error) => regex.test(error.field));
    };
    return (
        <div className="feedstock-container">
            <h2 className="container-title">Market and Regulatory Barriers</h2>
            {isHidden ? (
                <>
                    <div className="form-container">
                        <div className="error-container">
                            {marketErrors.map((error, index) => (
                                <div
                                    className="error-text"
                                    key={index}
                                    style={{ marginBottom: "10px" }}
                                >
                                    {error}
                                </div>
                            ))}
                        </div>
                        {isCBE ? (
                            <div className="question-group-input-first">
                                <Tooltip content={tAndP.find(item => item.property == "CBE JU KPI 8")?.tooltip}>
                                    <>
                                        <div className="question-text">
                                            CBE JU KPI 8  🛈 <br />
                                            <EditableTitle
                                                customLabelValue={customLabelValues.find(item => item.property == "KPI8" && item.table == "Market")}
                                                handleUpdateEditableTitle={handleUpdateEditableTitle} />
                                        </div>
                                        <div className="small-text">
                                            Please report the groups of the same type of action as a single contribution (e.g. "Participation in X number of pitch competitions" is reported as one action).
                                        </div>
                                    </>
                                </Tooltip>
                                <div className="row">
                                    <div className="col-md-6 col-sm-12">
                                        <DropdownNumberMandatory
                                            listInputs={ListOfHunderd}
                                            alwaysValid={false}
                                            label={
                                                "Number of actions implemented at project level to attract investment and/or to create awareness in the investment/funding community"
                                            }
                                            inputName={"numberOfActionsToAttractInvestmentOrCreateAwareness"}
                                            value={data.numberOfActionsToAttractInvestmentOrCreateAwareness}
                                            handleOnChange={handleOnChangeMarket}
                                        />
                                    </div>
                                    <div className="col-md-6 col-sm-12">
                                        <TextConfidential
                                            label={
                                                "Please provide more details about the implemented actions"
                                            }
                                            textValid={
                                                data.numberOfActionsToAttractInvestmentOrCreateAwarenessText.length >
                                                4 || data.numberOfActionsToAttractInvestmentOrCreateAwareness == 0
                                            }
                                            textValue={data.numberOfActionsToAttractInvestmentOrCreateAwarenessText}
                                            textName={"numberOfActionsToAttractInvestmentOrCreateAwarenessText"}
                                            onChange={handleOnChangeMarket}
                                            isConfidential={
                                                data.numberOfActionsToAttractInvestmentOrCreateAwarenessSensitive
                                            }
                                            confidentialInputName={
                                                "numberOfActionsToAttractInvestmentOrCreateAwarenessSensitive"
                                            }
                                            display={
                                                data.numberOfActionsToAttractInvestmentOrCreateAwareness == null ||
                                                data.numberOfActionsToAttractInvestmentOrCreateAwareness < 0
                                            }
                                            placeholder={tAndP.find(item => item.property == "CBE JU KPI 8")?.placeholder}
                                            maxCharacters={3000}
                                        />
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <div className="question-group-input-first">
                                <div className="question-text">
                                    Which of these aspects is your project contributing to?
                                </div>
                                <div className="row">
                                    <div className="col-md-6 col-sm-12">
                                        <DropDTextMultiple
                                            listInputs={
                                                dropdownValues.filter(
                                                    (item) => item.inputName == "contributions"
                                                )[0].listValue
                                            }
                                            label={""}
                                            inputName={"contributions"}
                                            value={data.contributions}
                                            handleOnChange={handleOnChangeMarket}
                                        />
                                    </div>
                                    <div className="col-md-6 col-sm-12">
                                        <TextConfidential
                                            label={
                                                "Please provide more details about the implemented actions"
                                            }
                                            textValid={
                                                data.contributionsText.length > 4 ||
                                                !data.contributions.includes("Other")
                                            }
                                            textValue={data.contributionsText}
                                            textName={"contributionsText"}
                                            onChange={handleOnChangeMarket}
                                            display={
                                                data.contributions.length == 0 ||
                                                data.contributions.includes("8")
                                            }
                                            isConfidential={data.contributionsSensitive}
                                            confidentialInputName={"contributionsSensitive"}
                                        />
                                    </div>
                                </div>
                            </div>
                        )}

                        <div className="question-group-input">
                            <div className="question-text">
                                Can the model (e.g. biorefinery concept, value chain, etc.. )
                                you develop be replicable to other regions?
                            </div>
                            <div className="row">
                                <div className="col-12">
                                    <DropdownStringMandatory
                                        listInputs={["-", "Yes", "No", "N/A"]}
                                        label={""}
                                        inputName={"relicableToOtherRegions"}
                                        value={data.relicableToOtherRegions}
                                        handleOnChange={handleOnChangeMarket}
                                        invalidValues={["", "-"]}
                                    />
                                </div>
                                <div className="col-12">
                                    <TextConfidential
                                        label={
                                            "Please indicate  the local characterisctics that need to be considered in order to ensure that the model is replicable in other regions"
                                        }
                                        textValid={data.relicableToOtherRegionsText.length > 4}
                                        textValue={data.relicableToOtherRegionsText}
                                        textName={"relicableToOtherRegionsText"}
                                        onChange={handleOnChangeMarket}
                                        isConfidential={data.relicableToOtherRegionsSensitive}
                                        confidentialInputName={"relicableToOtherRegionsSensitive"}
                                        display={data.relicableToOtherRegions != "Yes"}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="question-text no-margin-bottom">
                            EU Regulations and Directives
                        </div>
                        <div className="question-group-input">
                            <div className="questions-wrapper">
                            <CardHeader
                                isHidden={regulationsAreHidden}
                                toggleVisibility={toggleVisibilityRegulations}
                                cardName="Regulations"
                                handleDelete={null}
                                notValid={checkForErrorKeyword("Regulation")}
                            />
                            {regulationsAreHidden ? null : (
                                <>
                                    {data.rdcs.map((rdc, index) => (
                                        <RDC
                                            status={status}
                                            errors={errors
                                                .filter(
                                                    (error) => error.field === "Regulation[" + index + "]"
                                                )
                                                .map((error) => error.message)}
                                            dropdownValues={dropdownValues.filter(
                                                (item) => item.tab == "Regulation"
                                            )}
                                            key={index}
                                            data={rdc}
                                            handleOnChangeRDC={(e: any) =>
                                                handleOnChangeRDC(e, index)
                                            }
                                            handleDeleteRDC={() => handleDeleteRDC(index)}
                                        />
                                    ))}
                                    {status == 1 ? (
                                        <div className="mt-3">
                                            <div className="text-end margin-button">
                                                <button
                                                    type="button"
                                                    className="add-feedstock-btn nested-button mx-4 my-1"
                                                    onClick={handleAddRDC}
                                                >
                                                    <FontAwesomeIcon icon={plusDefinition} />
                                                    Add Regulation
                                                </button>
                                            </div>
                                        </div>
                                    ) : null}
                                </>
                            )}
                            </div>

                            <div className="questions-wrapper">
                            <CardHeader
                                isHidden={directivesAreHidden}
                                toggleVisibility={toggleVisibilityDirectives}
                                cardName="Directives"
                                handleDelete={null}
                                notValid={checkForErrorKeyword("Directive")}
                            />
                            {directivesAreHidden ? null : (
                                <>
                                    {data.directives.map((rdc, index) => (
                                        <Directive
                                            errors={errors
                                                .filter(
                                                    (error) => error.field === "Directive[" + index + "]"
                                                )
                                                .map((error) => error.message)}
                                            status={status}
                                            dropdownValues={dropdownValues.filter(
                                                (item) => item.tab == "Directive"
                                            )}
                                            key={index}
                                            data={rdc}
                                            handleOnChangeDirective={(e: any) =>
                                                handleOnChangeDirective(e, index)
                                            }
                                            handleDeleteDirective={() => handleDeleteDirective(index)}
                                        />
                                    ))}

                                    {status == 1 ? (
                                        <div className="mt-3">
                                            <div className="text-end margin-button">
                                                <button
                                                    type="button"
                                                    className="add-feedstock-btn nested-button mx-4 my-1"
                                                    onClick={handleAddDirective}
                                                >
                                                    <FontAwesomeIcon icon={plusDefinition} />
                                                    Add Directive
                                                </button>
                                            </div>
                                        </div>
                                    ) : null}
                                </>
                            )}
                            </div>
                        </div>
                    </div>
                </>
            ) : null}
        </div>
    );
}

export default Market;
const ListOfHunderd: string[] = ["-"].concat(
    Array.from({ length: 101 }, (_, index) => String(index))
);